import React from "react";

import RpMUIModal from "@/components/modals/RpMUIModal";
import { getFormatDate } from "@/helpers/utils";
import {
  RRD_LAYOUT_KEY,
  getRRDLayoutSpec,
  normalizeRRDPrintTypeContext,
} from "@/features/campaigns/direct-mail/rrd/utils/rrdLayoutHelper";
import RRdDirectMailMobileAssets from "./RRdDirectMailMobileAssets";
import RRDLayoutRenderer from "./layouts/RRDLayoutRenderer";
import type {
  RRDAssetGroups,
  RRDAssetSelection,
  RRDTemplateCommonProps,
  RRDTemplateSlot,
} from "./rrdTemplateTypes";

type RRDDirectMobileTemplateProps = RRDTemplateCommonProps & {
  onSelectImage: (_data: RRDAssetSelection) => void;
  assets?: RRDAssetGroups;
  isBulk?: boolean;
};

function RRDDirectMobileTemplate({
  heroImages = [],
  coupons = [],
  fixedImages = [],
  onSelectImage,
  frontCouponExpirationDate,
  backCouponExpirationDate,
  assets,
  printType,
  layoutKey,
  onRemoveAsset,
  isBulk = false,
}: RRDDirectMobileTemplateProps) {
  const [openModal, setOpenModal] = React.useState<RRDTemplateSlot | null>(
    null
  );

  const context = normalizeRRDPrintTypeContext({
    print_type: printType,
    layoutKey,
  });
  const layoutSpec =
    context.layoutSpec || getRRDLayoutSpec(RRD_LAYOUT_KEY.BASIC_POSTCARD_1H_6C);

  const handleSelectImage = (imageData: unknown) => {
    const sourceData = imageData;
    const targetData = openModal;
    onSelectImage({ sourceData, targetData });
    setOpenModal(null);
  };

  const frontExpirationDate = getFormatDate(frontCouponExpirationDate);
  const backExpirationDate = getFormatDate(
    backCouponExpirationDate || frontCouponExpirationDate
  );

  return (
    <>
      <RRDLayoutRenderer
        layoutSpec={layoutSpec}
        heroImages={heroImages}
        coupons={coupons}
        fixedImages={fixedImages}
        frontExpirationDate={frontExpirationDate}
        backExpirationDate={backExpirationDate}
        mode="mobile"
        onOpenMobileSlot={setOpenModal}
        onRemoveAsset={onRemoveAsset}
      />

      <RpMUIModal open={!!openModal} onClose={() => setOpenModal(null)}>
        <RRdDirectMailMobileAssets
          heroImages={heroImages}
          onSelectImage={handleSelectImage}
          clickType={openModal?.type}
          assets={assets}
          printType={printType}
          layoutKey={layoutSpec.layoutKey}
          isBulk={isBulk}
        />
      </RpMUIModal>
    </>
  );
}

export default RRDDirectMobileTemplate;
